import { useSelector } from '@/stores/hooks'
import { isClient } from '@/stores/meta'

export function useClient(): boolean {
	return useSelector(isClient)
}
